export * from '@shopify/shop-minis-platform'

export interface BaseComponentProps {
  className?: string
  children?: React.ReactNode
}

// Theme types
export interface ThemeConfig {
  colors?: {[key: string]: string}
  spacing?: {[key: string]: string}
  typography?: {[key: string]: string}
}

// Navigation
export const DATA_NAVIGATION_TYPE_ATTRIBUTE = 'data-navigation-type' as const
export const NAVIGATION_TYPES = {
  forward: 'forward',
  backward: 'backward',
  none: 'none',
} as const
